import React from "react";
import * as Icons from "lucide-react";
import { Avatar } from "@/components/personas/Avatar";

export const AREAS_PERSONA = ["contratos", "familia", "ocio"];

// Persona o entidad elegida, muy visible arriba.
export const Cabecera = ({ area, ent, persona, seccion, todos }) => {
  const I = Icons[area.icon] || Icons.Folder;
  return (
    <div data-testid="documentos-cabecera" className="flex items-center gap-4 bg-[#1C2421] text-white rounded-2xl p-4">
      {persona ? <Avatar persona={persona} size="lg" className="ring-2 ring-white/70" />
        : <span className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center shrink-0"><I size={30} /></span>}
      <div className="min-w-0">
        <p className="text-sm font-semibold text-white/70 flex items-center gap-1.5">{ent ? <><I size={15} /> {area.label}</> : "Área"}</p>
        <p data-testid="documentos-cabecera-nombre" className="font-heading text-2xl font-bold leading-tight break-words">{ent ? ent.label : area.label}</p>
        {!ent && !todos && <p className="text-base text-white/85 mt-0.5">Elige {AREAS_PERSONA.includes(area.id) ? "una persona" : area.id === "gastos" ? "una categoría" : "cuál"}</p>}
        {(seccion || todos) && <p data-testid="documentos-cabecera-apartado" className="text-base font-semibold text-white/85 mt-0.5">{todos ? "Todos los documentos" : seccion.label}</p>}
      </div>
    </div>
  );
};

export const VerTodos = ({ label, onClick, testid }) => (
  <button data-testid={testid} onClick={onClick}
    className="w-full min-h-[52px] mt-2 rounded-2xl border border-dashed border-[#C9C1B3] bg-transparent text-[#3A6B56] font-semibold text-base inline-flex items-center justify-center gap-2 hover:bg-white">
    <Icons.Layers size={18} /> {label}
  </button>
);
